import ClubDunningLevel from './ClubDunningLevel';
import ClubFee from './ClubFee';
import ClubFeeCategory from './ClubFeeCategory';

export default class ClubDunningSettings {
    static NONE = 0;
    static LEVEL1 = 1;
    static LEVEL2 = 2;
    static LEVEL3 = 3;
    static LEVEL4 = 4;

    constructor() {
        this.id = null;
        this.invoicePaymentDeadline = null;
        this.clubDunningLevel1 = new ClubDunningLevel();
        this.clubDunningLevel2 = new ClubDunningLevel();
        this.clubDunningLevel3 = new ClubDunningLevel();
        this.clubDunningLevel4 = new ClubDunningLevel();
        this.clubFeeCategory = null;
        this.clubFeeForChargeback = null;
        this.chargebackPdfText = '';
        this.chargebackPdfTextFooter = '';
        this.chargebackShowBankDetails = false;
        this.enabled = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubDunningSettings = new ClubDunningSettings();
        clubDunningSettings.id = data.id;
        clubDunningSettings.invoicePaymentDeadline = data.invoicePaymentDeadline;
        clubDunningSettings.clubDunningLevel1 = ClubDunningLevel.fromData(data.dunningLevel1);
        clubDunningSettings.clubDunningLevel2 = ClubDunningLevel.fromData(data.dunningLevel2);
        clubDunningSettings.clubDunningLevel3 = ClubDunningLevel.fromData(data.dunningLevel3);
        clubDunningSettings.clubDunningLevel4 = ClubDunningLevel.fromData(data.dunningLevel4);
        clubDunningSettings.clubFeeCategory = null;
        if (data.clubFeeCategoryId !== null) {
            clubDunningSettings.clubFeeCategory = ClubFeeCategory.fromData({ id: data.clubFeeCategoryId });
        }
        clubDunningSettings.clubFeeForChargeback = null;
        if (data.clubFeeForChargeback !== null) {
            data.clubFeeForChargeback.priceHistory = data.clubFeeForChargebackPriceHistory;
            clubDunningSettings.clubFeeForChargeback = ClubFee.fromData(data.clubFeeForChargeback);
        }
        clubDunningSettings.chargebackPdfText = data.chargebackPdfText;
        clubDunningSettings.chargebackPdfTextFooter = data.chargebackPdfTextFooter;
        clubDunningSettings.chargebackShowBankDetails = data.chargebackShowBankDetails;
        clubDunningSettings.enabled = data.enabled;

        return clubDunningSettings;
    }
}
